import tracker from '../../components/tracker/publish'
import Analytics from '../analytics/Analytics'

const trackerHandler = (title, url, idx, quicklinkDestination, quicklinkType, isKnowledgeBase) => {
  let eventLabel
  if (isKnowledgeBase) {
    eventLabel = {
      'Title': title,
      'Link': url,
      'Type': 'knowledge base parent'
    }
    Analytics.send('Homepage', 'Category clicked', eventLabel)
    return
  }

  eventLabel = {
    Title: title,
    Position: idx + 1,
    Link: url
  }
  Analytics.send('Homepage', 'Quick link clicked', eventLabel)

  tracker.trackEvent('userevent', {
    type: 'Quick Link Clicked',
    quick_link_title: title,
    quick_link_url: url,
    quick_link_position: idx + 1,
    quick_link_destination: quicklinkDestination,
    quick_link_type: quicklinkType
  })
}

const QuickLink = props => {
  const { item, borderRadius, enableBorder, isVisibleDesktop, isKnowledgeBase } = props
  let { idx } = props
  const { imageSrc, title, url, openNewTab, description } = item
  const iconSrc = isKnowledgeBase ? item.thumbnailUrl : item.iconSrc
  const style = { borderRadius: borderRadius ? borderRadius + 'px' : '0' }
  const quicklinkHeroClassName = iconSrc ? 'padding__icon quicklink__hero' : 'quicklink__hero'
  const quicklinkDestination = url.indexOf(window.location.hostname) > -1 ? 'internal' : 'external'
  const urlTarget = openNewTab ? '_blank' : ''
  let quicklinkBoxClassName = ''
  quicklinkBoxClassName += enableBorder ? ' has-border' : ''
  quicklinkBoxClassName += !isVisibleDesktop ? ' is-hidden-mobile-up' : ''

  let quicklinkType = ''
  if (imageSrc) {
    quicklinkType = 'image'
  } else if (iconSrc) {
    quicklinkType = 'icon'
  } else {
    quicklinkType = 'text'
  }

  return (
    <li
      class={`featured-topic quicklink__box${quicklinkBoxClassName}`}
      style={style}
      onClick={() => trackerHandler(title, url, idx, quicklinkDestination, quicklinkType, isKnowledgeBase)}>
      <a href={url} class='quicklink__url' target={urlTarget}>
        {iconSrc || imageSrc
          ? <div class={quicklinkHeroClassName} style={{ backgroundImage: `url(${iconSrc || imageSrc})` }} />
          : null }
        <div class='quicklink__title'>
          <h3>{title}</h3>
          <p class='text--meta'>{description}</p>
        </div>
      </a>
    </li>
  )
}

export default QuickLink
